Vue.filter('forceHttps', function(value) {
    if (!value) return '';
    return value.replace('http://', 'https://');
});

Vue.filter('stripTags', function(value) {
    if (!value) return '';
    return unescape(value.replace(/&lt;.+?&gt;/g, ''));
});

Vue.filter('stripTagsShort', function(value) {
    if (!value) return '';
    return value.replace(/&lt;.+?&gt;/g, '').substr(0, 80) + '...';
});

Vue.filter('splitMore', function(value) {
    if (!value) return ''
    if (value.search("<!--more-->") == -1) return value
    return value.split('<!--more-->')[0]
});

Vue.filter('formatDate', function(date, dateFormat, formatDate, lang) {
    if (date) {
      //moment.locale(lang);
      return moment(date, dateFormat).format(formatDate);
    }
});

Vue.filter('formatTimestamp', function(value, format, lang) {
    if (value) {
      moment.locale(lang);
      return moment.unix(String(value)).format(format)
    }
}); 